var evapCoil = document.getElementById("evapCoil");
var evapInnerContent = document.getElementById("content-1-inner");
var evapContent = document.getElementById("content-1");
var airHandler = document.getElementById("airHandler");
var airHandlerInnerContent = document.getElementById("content-2-inner");
var airContent = document.getElementById("content-2");
var unitHeater = document.getElementById("unitHeater");
var unitInnerContent = document.getElementById("content-3-inner");
var unitContent = document.getElementById("content-3");
var titleEvap = document.getElementById("title-evap");
var titleAir = document.getElementById("title-air");
var titleHeater = document.getElementById("title-heater");
var backButton = document.querySelectorAll(".back");

if (evapCoil) {
  console.log("evapCoil", evapCoil.dataset.redirectMobile);
  if (window.innerWidth > 768 || evapCoil.dataset.redirectMobile !== "1") {
    evapCoil.addEventListener("click", evaphideOthers, false);
    function evaphideOthers() {
      airHandlerInnerContent?.classList.add("hide");
      unitInnerContent?.classList.add("hide");
      evapInnerContent?.classList.add("hide");
      airHandlerInnerContent?.classList.remove("show");
      unitInnerContent?.classList.remove("show");
      evapInnerContent?.classList.remove("show");
      airContent?.classList.remove("show");
      unitContent?.classList.remove("show");
      airContent?.classList.add("hide");
      unitContent?.classList.add("hide");
      evapContent?.classList.remove("hide");
      evapContent?.classList.add("show");
      titleHeater?.classList.remove("active");
      titleAir?.classList.remove("active");
      titleEvap?.classList.add("active");
      return false;
    }
  } else {
    evapCoil.addEventListener("click", evapGoToPage, false);
    function evapGoToPage() {
      window.location.href = "/evaporator-coils/";
      titleHeater?.classList.remove("active");
      titleAir?.classList.remove("active");
      titleEvap?.classList.add("active");
    }
  }
}

if (airHandler) {
  if (window.innerWidth > 768 || airHandler.dataset.redirectMobile !== "1") {
    airHandler.addEventListener("click", airhideOthers, false);
    function airhideOthers() {
      airHandlerInnerContent?.classList.add("hide");
      unitInnerContent?.classList.add("hide");
      evapInnerContent?.classList.add("hide");
      airHandlerInnerContent?.classList.remove("show");
      unitInnerContent?.classList.remove("show");
      evapInnerContent?.classList.remove("show");
      evapContent?.classList.remove("show");
      unitContent?.classList.remove("show");
      evapContent?.classList.add("hide");
      unitContent?.classList.add("hide");
      airContent?.classList.remove("hide");
      airContent?.classList.add("show");
      titleHeater?.classList.remove("active");
      titleEvap?.classList.remove("active");
      titleAir?.classList.add("active");
      return false;
    }
  } else {
    airHandler.addEventListener("click", airGoToPage, false);
    function airGoToPage() {
      window.location.href = "/adp-air-handlers/";
      titleHeater?.classList.remove("active");
      titleEvap?.classList.remove("active");
      titleAir?.classList.add("active");
    }
  }
}

if (unitHeater) {
  if (window.innerWidth > 768 || unitHeater.dataset.redirectMobile !== "1") {
    unitHeater.addEventListener("click", unithideOthers, false);
    function unithideOthers() {
      airHandlerInnerContent?.classList.add("hide");
      unitInnerContent?.classList.add("hide");
      evapInnerContent?.classList.add("hide");
      airHandlerInnerContent?.classList.remove("show");
      unitInnerContent?.classList.remove("show");
      evapInnerContent?.classList.remove("show");
      evapContent?.classList.remove("show");
      airContent?.classList.remove("show");
      evapContent?.classList.add("hide");
      airContent?.classList.add("hide");
      unitContent?.classList.remove("hide");
      unitContent?.classList.add("show");

      return false;
    }
  } else {
    unitHeater.addEventListener("click", unitHeatersPage, false);
    function unitHeatersPage() {
      window.location.href = "/unit-heaters/";
      titleAir?.classList.remove("active");
      titleEvap?.classList.remove("active");
      titleHeater?.classList.add("active");
    }
  }
}

backButton.forEach((item) => {
  item.addEventListener("click", backHideAll, false);
  function backHideAll() {
    evapContent?.classList.remove("show");
    airContent?.classList.remove("show");
    unitContent?.classList.remove("show");
    evapContent?.classList.add("hide");
    airContent?.classList.add("hide");
    unitContent?.classList.add("hide");
    airHandlerInnerContent?.classList.add("show");
    unitInnerContent?.classList.add("show");
    evapInnerContent?.classList.add("show");
    return false;
  }
});
